import { SpanInfoEnhanced, SymetraDateTimeEnhanced } from './../../api/benefits-clients';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';
import { SpanInfo, SymetraDateTime } from '@benefitsui/app/api/benefits-clients';
import { Constants } from '@benefitsui/app/pages/billing-page/billing-page.types';

export class DateTimeUtilities {
  static dateToString(date: Date): string {
    const dateString = date.toLocaleDateString(Defaults.usLocale, Defaults.dateFormatOptions);

    return dateString;
  }

  static dateToSymetraDateTime(date: Date): SymetraDateTime {
    const unixMilliseconds = date.valueOf();

    const symetraDateTime = {
      unixMilliseconds: unixMilliseconds
    } as SymetraDateTime;

    return symetraDateTime;
  }

  static spanInfoEnhancedToString(spanInfoEnhanced: SpanInfoEnhanced | undefined): string {
    let spanInfoString = Defaults.stringEmpty;

    if (spanInfoEnhanced !== undefined) {
      const beginDateString = DateTimeUtilities.symetraDateTimeEnhancedToString(spanInfoEnhanced.begin);
      const endDateString = DateTimeUtilities.symetraDateTimeEnhancedToString(spanInfoEnhanced.end);

      spanInfoString = `${beginDateString} - ${endDateString}`;
    }

    return spanInfoString;
  }

  static spanInfoToString(spanInfo: SpanInfo): string {
    const beginDateString = DateTimeUtilities.symetraDateTimeToString(spanInfo.begin);
    const endDateString = DateTimeUtilities.symetraDateTimeToString(spanInfo.end);

    const spanInfoString = `${beginDateString} - ${endDateString}`;

    return spanInfoString;
  }

  static stringToSpanInfo(periodString: string): SpanInfo | undefined {
    let spanInfo = undefined;

    if (periodString != null && periodString != Defaults.stringEmpty) {
      const dateStringArray = periodString.split('-');

      const dateArray = dateStringArray.map((dateString) => {
        const dateStringClean = dateString.trim();
        const date = new Date(dateStringClean);
        const symetraDateTime = DateTimeUtilities.dateToSymetraDateTime(date);

        return symetraDateTime;
      });

      spanInfo = {
        begin: dateArray[0],
        end: dateArray[1]
      };
    }

    return spanInfo;
  }

  static symetraDateTimeEnhancedToString(symetraDateTimeEnhanced: SymetraDateTimeEnhanced | undefined): string {
    const dateString =
      symetraDateTimeEnhanced === undefined
        ? Constants.StringEmpty
        : DateTimeUtilities.unixMillisecondToString(symetraDateTimeEnhanced.unixMilliseconds);

    return dateString;
  }

  static symetraDateTimeToString(symetraDateTime: SymetraDateTime): string {
    const symetraDateTimeString = `${symetraDateTime}`;
    const date = new Date(symetraDateTimeString);
    const dateString = DateTimeUtilities.dateToString(date);

    return dateString;
  }

  static unixMillisecondToString(unixMilliseconds: number): string {
    const date = new Date(unixMilliseconds);
    const dateString = DateTimeUtilities.dateToString(date);

    return dateString;
  }
}
